export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-list-bullet-3c42ff830c15a8efb02f751a476f83cf.svg";